<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Sub-category</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Sub-category</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="card" id="department-add">
        <div class="overlay" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <form @submit.prevent="handleSubmission()" method="POST" novalidate>
          <div class="card-header">
            <h3 class="card-title" v-if="!is_edit">Create</h3>
            <h3 class="card-title" v-if="is_edit">Edit</h3>
            <div class="card-tools">
              <router-link class="btn btn-info" :to="{ name: 'Categories' }"
                ><i class="fas fa-list"></i> List
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group required">
              <label class="control-label">Category</label>
              <multiselect
                name="category"
                v-model="inputs.category_id"
                :options="categories.map((cat) => cat.id)"
                :custom-label="
                  (opt) => categories.find((x) => x.id == opt).name
                "
                placeholder="Pick category"
                :searchable="true"
                :multiple="false"
                v-bind:class="{ 'has-error': errors.has('category') }"
                v-validate="'required'"
              >
              </multiselect>
              <div class="help text-danger" v-show="errors.has('category')">
                {{ errors.first("category") }}
              </div>
            </div>
            <div class="form-group required">
              <label for="sub_category_name" class="control-label"
                >Sub-category name (English)</label
              >
              <input
                type="text"
                id="sub_category_name"
                name="sub_category_name"
                v-bind:class="{ 'has-error': errors.has('sub_category_name') }"
                v-validate="'required'"
                v-model="inputs.sub_category_name"
                class="form-control"
                placeholder="Name (English)"
              />
              <div
                class="help text-danger"
                v-show="errors.has('sub_category_name')"
              >
                {{ errors.first("sub_category_name") }}
              </div>
            </div>
            <div class="form-group">
              <label for="sub_category_name" class="control-label"
                >Sub-category name (Bangla)</label
              >
              <input
                type="text"
                id="sub_category_name_bn"
                name="sub_category_name_bn"
                v-model="inputs.sub_category_name_bn"
                class="form-control"
                placeholder="Name (Bangla)"
              />
              <div
                class="help text-danger"
                v-show="errors.has('sub_category_name')"
              >
                {{ errors.first("sub_category_name") }}
              </div>
            </div>
            <div class="form-group required">
              <label for="description" class="control-label"
                >Description (English)</label
              >
              <input
                type="text"
                id="description"
                name="description"
                v-bind:class="{ 'has-error': errors.has('description') }"
                v-validate="'required'"
                v-model="inputs.description"
                class="form-control"
                placeholder="Description (English)"
              />
              <div class="help text-danger" v-show="errors.has('description')">
                {{ errors.first("description") }}
              </div>
            </div>
            <div class="form-group">
              <label for="description" class="control-label"
                >Description (Bangla)</label
              >
              <input
                type="text"
                id="description_bn"
                name="description_bn"
                v-model="inputs.description_bn"
                class="form-control"
                placeholder="Description (Bangla)"
              />
            </div>
          </div>
          <div class="card-footer">
            <button type="submit" v-if="!is_edit" class="btn btn-primary">
              Submit
            </button>
            <button type="submit" v-if="is_edit" class="btn btn-primary">
              Update
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { CategoryAPI } from "@/services/api";

export default {
  name: "CategoryForm",
  metaInfo: {
    title: "Category Form | Dotlines",
  },
  data: () => ({
    inputs: {},
    categories: [],
    is_loading: false,
    is_edit: false,
    params: {},
  }),
  methods: {
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.is_edit) {
            CategoryAPI.subCategoryUpdate(this.params.id, this.inputs)
              .then((response) => {
                this.$router.push({ name: "SubCategories" });
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.data);
              });
          } else {
            CategoryAPI.subCategoryStore(this.inputs)
              .then((response) => {
                this.$router.push({ name: "SubCategories" });
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                if (error.data.status === 500) {
                  this.$toaster.error(error.data.message);
                }
                this.$setErrorsFromResponse(error.data);
              });
          }
        }
      });
    },
    async show(id) {
      await CategoryAPI.subCategoryShow(id).then((item) => {
        this.inputs = item;
        if (!_.isEmpty(item.category) && typeof item.category !== undefined) {
          this.categories[0] = item.category;
        }
      });
    },
    getCategories() {
      CategoryAPI.getAllCategories().then((categories) => {
        this.categories = categories;
      });
    },
    async initialLoad() {
      this.is_loading = true;
      await this.getCategories();
      this.params = this.$route.params;
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.show(this.params.id);
      }
      this.is_loading = false;
    },
  },
  async mounted() {
    await this.initialLoad();
  },
};
</script>
